import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { useAppSelector } from 'src/store/store';
import { setSelectedTaskTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import {
  ADMIN_CONFIG_TASK_TABS,
  ADMIN_CONFIG_PATHS,
  AdminConfigTabMap,
} from 'src/store/adminConfigPageSlice/common/constants';

/**
 * Toggle the Task/TaskGroup Tables
 */
const TaskConfigurationTabs = () => {
  const { selectedTaskTab } = useAppSelector((state) => state.adminConfigPage);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectTab = (newTab: string) => {
    dispatch(setSelectedTaskTab(newTab));
    const newPath = AdminConfigTabMap.TaskConfig.get(newTab);
    navigate(newPath, { replace: true });
  };

  // Set tab from URL, default to "Tasks" if none selected
  useEffect(() => {
    const tab = AdminConfigTabMap.TaskConfig.get(location.pathname);
    if (!!tab) {
      dispatch(setSelectedTaskTab(tab));
    } else if (location.pathname === ADMIN_CONFIG_PATHS.Task) {
      selectTab(ADMIN_CONFIG_TASK_TABS.Task);
    }
  }, [location.pathname]);

  return (
    <TabGroupLib value={selectedTaskTab} onChange={selectTab}>
      <Tab value={ADMIN_CONFIG_TASK_TABS.Task}>Tasks</Tab>
      <Tab value={ADMIN_CONFIG_TASK_TABS.TaskGroup}>Task Groups</Tab>
    </TabGroupLib>
  );
};

export default TaskConfigurationTabs;
